import type { FlashData, SharedProps } from "@/types"
import { AuthShell } from "@/components/auth-shell"
import { AuthStatus } from "@/components/auth-status"
import { LoginForm } from "@/components/login-form"

type SignInPageProps = SharedProps & {
  flash: FlashData
  emailHint?: string
  paths: {
    forgotPassword: string
    signIn: string
    signUp: string
  }
}

export default function SignInPage({ emailHint, flash, paths }: SignInPageProps) {
  return (
    <AuthShell
      heroTitle="Your guests deserve a great first impression."
      heroDescription="Innly helps you build personalized local guides that guests actually use — delivered the moment they connect to your WiFi."
      heroPoints={[
        "Set up your property guide in minutes, not hours.",
        "WiFi activation drives 3× more engagement than QR codes alone.",
        "Your guests get tailored local picks. You get the data.",
      ]}
      pageTitle="Sign in"
    >
      <div className="flex flex-col gap-4">
        <AuthStatus flash={flash} />
        <LoginForm emailHint={emailHint} paths={paths} />
      </div>
    </AuthShell>
  )
}
